import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {environment} from '../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, map} from "rxjs/operators";
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private http: HttpClient, private authService: AuthService , private router: Router ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.authService.isAuthenticated().subscribe(rs => {
      if (rs.kapo_session_id != localStorage.getItem('kapo_session_id')) {
        this.authService.deleteSession();
      }
    }, error => {
      this.router.navigate(['/login']);
      return false;
    });

    if (this.authService.checkSession()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }

}
